import type { App } from 'vue';
import * as Sentry from '@sentry/vue';

import { VERSION } from '@/configs/env';
import { SENTRY_DSN, SentrySymbol } from '@/configs/sentry';

import { router } from '@/plugins/router';

const install = (app: App) => {
  Sentry.init({
    app,
    enabled: false,
    dsn: SENTRY_DSN,
    integrations: [
      Sentry.browserSessionIntegration(),
      Sentry.browserTracingIntegration({ router }),
    ],
    tracesSampleRate: 0.4,
    release: VERSION,
    environment: import.meta.env.MODE,
    ignoreErrors: [
      /SocketProtocolError/,
      'Failed to load https://chat.irfarabi.net/packs/js/sdk.js',
      'Error: Failed to load (packs/js/sdk)',
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications.',
      'TypeError: NetworkError when attempting to fetch resource.',
      'TypeError: Failed to fetch dynamically imported module:',
      'UnhandledRejection: Non-Error promise rejection captured with keys: message',
      'UnhandledRejection: Non-Error promise rejection captured with keys: code, message, name, response',
    ],
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    ignoreUrls: [/extensions\//i, /^chrome:\/\//i],
    autoSessionTracking: false,
    trackComponents: true,
  });

  app.config.globalProperties.$sentry = Sentry;
  app.provide(SentrySymbol, Sentry);
};

export { install };
